import { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('pwa-dismissed')) {
      setDismissed(true);
      return;
    }
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('pwa-dismissed', '1');
  };

  if (!deferredPrompt || dismissed) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-[340px] z-50 animate-in slide-in-from-bottom-4 fade-in duration-300"
      data-testid="pwa-install-prompt"
    >
      <div className="bg-slate-900 border border-slate-700 rounded-2xl p-4 shadow-2xl flex items-start gap-3">
        <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center shrink-0">
          <span className="text-white font-bold text-lg font-['Outfit']">Q</span>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-white font-['Outfit']">Install QuickFinance</p>
          <p className="text-xs text-slate-400 mt-0.5">Add to your home screen for quick access</p>
          <button
            onClick={handleInstall}
            className="mt-2.5 inline-flex items-center gap-1.5 text-xs font-medium text-white bg-blue-600 hover:bg-blue-700 px-3 py-1.5 rounded-lg transition-colors"
            data-testid="pwa-install-btn"
          >
            <Download className="w-3.5 h-3.5" />
            Install App
          </button>
        </div>
        <button
          onClick={handleDismiss}
          className="text-slate-500 hover:text-slate-300 transition-colors p-0.5"
          data-testid="pwa-dismiss-btn"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
